export default __webpack_public_path__ + "static/media/Flizone.8fa5b2a3.png";